import { RxFArtClientDocument, RxFArtComptaDocument, RxFArticleDocument, RxFClientDocument, RxFConditionDocument, RxFFamClientDocument, RxFFamComptaDocument, RxFFamTarifDocument, RxFFamTarifQteDocument, RxFModeleDocument, RxFTarifCondDocument, RxFTarifDocument, RxFTarifGamDocument, RxFTarifQteDocument, RxFTarifSelectDocument } from "../@services/m-cashdesk-core-rxdb";

export class CluTickContextItem {
    ARTICLE : RxFArticleDocument;
    CLIENT : RxFClientDocument;
    ARTCLIENT_ITEMS : RxFArtClientDocument[]; 
    ARTCOMPTA_ITEMS : RxFArtComptaDocument[]; 
    FAMCLIENT_ITEMS : RxFFamClientDocument[]; 
    FAMTARIF_ITEMS : RxFFamTarifDocument[]; 
    FAMTARIFQTE_ITEMS : RxFFamTarifQteDocument[]; 
    FAMCOMPTA_ITEMS : RxFFamComptaDocument[]; 
    TARIFGAM_ITEMS : RxFTarifGamDocument[];
    TARIFQTE_ITEMS : RxFTarifQteDocument[];
    CONDITION_ITEMS : RxFConditionDocument[];
    TARIFCOND_ITEMS : RxFTarifCondDocument[];
    MODELE_ITEMS : RxFModeleDocument[];

    TARIF_ITEMS : RxFTarifDocument[];
    TARIFSELECT_ITEMS : RxFTarifSelectDocument[];

    CLU_ARTSTOCK_ITEM : CluArtStockItem;
}

export class CluArtStockItem {
    CLU_CURRENT_CASHDESK_QTE_VENTE : number = 0;
    CLU_CURRENT_CASHDESK_QTE_ACTIF : number = 0;
    CLU_CURRENT_CASHDESK_QTE_CLOSED : number = 0;
    CLU_CURRENT_CASHDESK_QTE_PAUSED : number = 0;
}